import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { ListsApi } from '../lists.api';
import { ListsService } from '../lists.service';
import { SharedModule } from '@app/shared/shared.module';
import { SelectComponent } from "../../../shared/components/forms/select/select.component";
import { InputComponent } from "../../../shared/components/forms/input/input.component";
import { Toaster } from '@app/services/toaster/toaster.service';

@Component({
	selector: 'app-recover-form',
	standalone: true,
	imports: [
    SharedModule,
    SelectComponent,
    InputComponent
],
	providers: [
		ListsService,
		ListsApi,
	],
	templateUrl: './recover-form.component.html',
	styleUrl: './recover-form.component.scss'
})
export class RecoverFormComponent implements OnInit {
	public loading:boolean = false;
	public years: any[] = [];
	public year?:any;
	public showYearDrop: boolean = false;
	public email: string = "";
	public success:boolean = false;

	constructor (
		private toaster: Toaster,
		private settings: SettingsService,
		private service: ListsService,
	) { }

	private addYearToDrop(year:number) {
		this.years.push(this.getYearOpt(year));
	}
	private getYearOpt(year:number) {
		return { name: year, id: year };
	}

	ngOnInit(): void {
		this.loading = true;
		this.settings.loadSettings()
			.then((st: any) => {
				const yearSub = st.subscription_year;
				const year = st.year;
				if(year != yearSub) {
					this.addYearToDrop(yearSub);
					this.addYearToDrop(year);
				} else {
					this.addYearToDrop(year);
					this.addYearToDrop(year-1);
				}
				this.showYearDrop = true;
				this.year = this.getYearOpt(year);
				this.loading = false;
			});
	}

	public recover(): void {
		this.loading = true;
		const e = this.email.trim();
		const y = this.year?.id;
		this.service.recover(e, y)
			.subscribe({
				next: (rs) => {
					if(rs.mail_send.sent_success) {
						this.toaster.success(`Sua lista foi enviada por e-mail!`);
					}
					this.success = true;
					this.loading = false;
				},
				error: (err) => {
					console.error(err);
					if(err.code = 4043) {
						this.toaster.error(`Nenhuma lista encontrada com o e-mail ${e}`);
					}
					this.loading = false;
				}
			})
	}

}
